import {useFilesPageInfo} from '@github-ui/code-view-shared/contexts/FilesPageInfoContext'
import {useCurrentRepository} from '@github-ui/current-repository'
import {useLatestCommit} from '@github-ui/use-latest-commit'
import {AlertIcon} from '@primer/octicons-react'
import {Flash, type SxProp} from '@primer/react'
import {Octicon} from '@primer/react/deprecated'

export function SpoofedCommitWarning() {
  if (!useLatestCommitIsSpoofed()) {
    return null
  }

  return <SpoofedCommitWarningBanner sx={{mt: 3}} />
}

export function SpoofedCommitWarningBanner({sx}: {sx?: SxProp['sx']}) {
  return (
    <Flash variant="warning" sx={sx} data-testid="spoofed-commit-warning-banner">
      <Octicon icon={AlertIcon} />
      <span>
        This commit does not belong to any branch on this repository, and may belong to a fork outside of the
        repository.
      </span>
    </Flash>
  )
}

export function useLatestCommitIsSpoofed() {
  const repo = useCurrentRepository()
  const {refInfo, path} = useFilesPageInfo()
  const [latestCommit] = useLatestCommit(repo.ownerLogin, repo.name, refInfo.name, path)
  return latestCommit?.isSpoofed ?? false
}

try{ SpoofedCommitWarning.displayName ||= 'SpoofedCommitWarning' } catch {}
try{ SpoofedCommitWarningBanner.displayName ||= 'SpoofedCommitWarningBanner' } catch {}